import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import qs from 'qs'
import LazyLoad from 'vue-lazyload'
import 'babel-polyfill'
import './common/scss/index.scss'
import './common/util/flexible.js'
import './common/util/html2canvas.js'
import {fetch,post} from './common/util/http.js'

Vue.use(LazyLoad,{
	error: require('./common/images/error-img.png'),
	loading: require('./common/images/loading-img.gif'),
})

Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$qs = qs
Vue.prototype.$fetch = fetch
Vue.prototype.$post = post
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js